import { ButtonStyled, OrderActionWrapperStyled } from './OrderAction.style';
import { useDomainConfig } from 'hooks/useDomainConfig';
import { useRouter } from 'next/router';
import { ArrowIcon, SimpleCheckmarkIcon, SpinnerIcon } from 'public/svg/IconsSvg';
import { useSessionStore } from 'store/useSessionStore';
import { getInternationalizedStaticUrls } from 'utils/getInternationalizedStaticUrls';

type OrderActionProps = {
    buttonText: string;
    buttonLink?: string;
    hasDisabledLook: boolean;
    isLoading?: boolean;
    isLastStep: boolean;
    desktopAlign?: 'center' | 'right';
    nextStepClickHandler?: () => void;
    type?: 'styled' | 'tailwind';
};

const OrderAction: FC<OrderActionProps> = ({
    buttonText,
    buttonLink,
    hasDisabledLook,
    isLoading,
    isLastStep,
    desktopAlign,
    nextStepClickHandler,
    type = 'styled',
    className,
}) => {
    const testIdentifier = 'blocks-orderaction';
    const { updateGeneralState } = useSessionStore((s) => s);
    const domainConfig = useDomainConfig();
    const [transportAndPaymentUrl] = getInternationalizedStaticUrls(['/order/transport-and-payment'], domainConfig.url);
    const router = useRouter();

    const onNextStepHandler = () => {
        if (buttonLink !== undefined) {
            router.push(buttonLink);
        }
        if (buttonLink === transportAndPaymentUrl) {
            updateGeneralState({ destinationOfRedirect: 'transport-and-payment' });
            updateGeneralState({ isPageLoading: true });
        } else {
            updateGeneralState({ destinationOfRedirect: '' });
            updateGeneralState({ isPageLoading: false });
        }
        if (nextStepClickHandler !== undefined) {
            nextStepClickHandler();
        }
    };

    const actionButton = (
        <ButtonStyled
            type="submit"
            variant="primary"
            hasDisabledLook={hasDisabledLook}
            onClick={onNextStepHandler}
            data-testid={testIdentifier}
            isDisabled={isLoading}
        >
            {isLoading && <SpinnerIcon className="h-5 w-5" />}
            {isLastStep && !isLoading && <SimpleCheckmarkIcon className="h-[22px] w-[22px]" />}
            <span>{buttonText}</span>
            {!isLastStep && <ArrowIcon className="h-[22px] w-[22px] -rotate-90" />}
        </ButtonStyled>
    );

    if (type === 'tailwind') {
        return <div className={className}>{actionButton}</div>;
    }

    return <OrderActionWrapperStyled desktopAlign={desktopAlign}>{actionButton}</OrderActionWrapperStyled>;
};

export default OrderAction;
